export const sv = {
  title: 'Kalender',
  subtitle: 'Hantera dina bokningar och schemaläggning',
  today: 'Idag',
  dayMon: 'Mån',
  dayTue: 'Tis',
  dayWed: 'Ons',
  dayThu: 'Tors',
  dayFri: 'Fre',
  daySat: 'Lör',
  daySun: 'Sön',
  selectDate: 'Välj ett datum',
  customer: 'Kund',
  statusConfirmed: 'Bekräftad',
  noBookingsForDate: 'Inga bokningar för detta datum',
  selectDatePrompt: 'Klicka på ett datum i kalendern för att se bokningar',
  upcomingBookings: 'Kommande bokningar',
  newBooking: 'Ny bokning',
  newBookingHint: 'För kunder som ringer in. Jobbet bekräftas direkt och betalas på verkstaden.',
  newBookingFailed: 'Kunde inte skapa bokningen',
  fieldName: 'Kundens namn',
  fieldPhone: 'Telefon',
  fieldEmail: 'E-post (valfritt)',
  fieldReg: 'Registreringsnummer',
  fieldService: 'Tjänst',
  fieldServicePlaceholder: 'Välj tjänst',
  fieldTime: 'Datum och tid',
  fieldNotes: 'Önskemål / anteckning',
  cancel: 'Avbryt',
  createBooking: 'Skapa bokning',
}

export const en: typeof sv = {
  title: 'Calendar',
  subtitle: 'Manage your bookings and scheduling',
  today: 'Today',
  dayMon: 'Mon',
  dayTue: 'Tue',
  dayWed: 'Wed',
  dayThu: 'Thu',
  dayFri: 'Fri',
  daySat: 'Sat',
  daySun: 'Sun',
  selectDate: 'Select a date',
  customer: 'Customer',
  statusConfirmed: 'Confirmed',
  noBookingsForDate: 'No bookings for this date',
  selectDatePrompt: 'Click a date in the calendar to see bookings',
  upcomingBookings: 'Upcoming bookings',
  newBooking: 'New booking',
  newBookingHint: 'For customers who call in. The job is confirmed right away and paid at the garage.',
  newBookingFailed: 'Could not create the booking',
  fieldName: 'Customer name',
  fieldPhone: 'Phone',
  fieldEmail: 'Email (optional)',
  fieldReg: 'Registration number',
  fieldService: 'Service',
  fieldServicePlaceholder: 'Choose a service',
  fieldTime: 'Date and time',
  fieldNotes: 'Request / note',
  cancel: 'Cancel',
  createBooking: 'Create booking',
}
